import { DistributionPromoDetail } from "./distribution-promo-detail"
import { DistributionPromo } from "./distribution-promo";

export class PromoCondition { 
    private distribution_promo: DistributionPromo;
    public get _distribution_promo(): DistributionPromo {
        return this.distribution_promo;
    }
    public set _distribution_promo(value: DistributionPromo) {
        this.distribution_promo = value;
    }
    private distribution_promo_detail: DistributionPromoDetail[];
    public get _distribution_promo_detail(): DistributionPromoDetail[] {
        return this.distribution_promo_detail;
    }
    public set _distribution_promo_detail(value: DistributionPromoDetail[]) {
        this.distribution_promo_detail = value;
    }

}